import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var sidebarMenuComponentName = 'QuantumSidebarMenu';
export function getSidebarMenuUtilityClass(slot) {
    return generateUtilityClass(sidebarMenuComponentName, slot);
}
export var sidebarMenuClasses = generateUtilityClasses(sidebarMenuComponentName, [
    'root',
    'icon',
    'iconExpanded',
    'region',
    'items',
]);
